import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, css, stretch } from '@mgmresorts/wcl-styled';

var _templateObject, _templateObject2, _templateObject3;
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var StyledHiddenSelect = styled.select(function (props) {
  return props.enabled ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n        width: 100%;\n        height: 100%;\n        display: block;\n        border: none;\n        border-radius: 0;\n        -webkit-appearance: none;\n        cursor: pointer;\n        opacity: 0;\n      "])), stretch()) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        display: none;\n      "])));
});

export { StyledHiddenSelect, StyledWrapper };
